import request from '@/utils/request'

/**
 * 获取晒家列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getShowHomeList(data) {
  return request({
    url: 'api/getShowHomeList',
    method: 'post',
    params: data
  })
}

/**
 * 删除晒家
 * @param data
 * @returns {AxiosPromise}
 */
export function delShowHome(data) {
  return request({
    url: 'api/delShowHome',
    method: 'post',
    params: data
  })
}

/**
 * 修改或添加晒家
 * @param data
 * @returns {AxiosPromise}
 */
export function addOrEditShowHome(data) {
  return request({
    url: 'api/addOrEditShowHome',
    method: 'post',
    params: data
  })
}

/**
 * 根据id获取单个晒家详情
 * @param data
 * @returns {AxiosPromise}
 */
export function getShowHomeInfo(data) {
  return request({
    url: 'api/getShowHomeInfo',
    method: 'post',
    params: data
  })
}

/**
 * 获取案例列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getCaseList(data) {
  return request({
    url: 'api/getCaseList',
    method: 'post',
    params: data
  })
}

/**
 * 删除案例
 * @param data
 * @returns {AxiosPromise}
 */
export function delCase(data) {
  return request({
    url: 'api/delCase',
    method: 'post',
    params: data
  })
}

/**
 * 修改或添加案例
 * @param data
 * @returns {AxiosPromise}
 */
export function addOrEditCase(data) {
  return request({
    url: 'api/addOrEditCase',
    method: 'post',
    params: data
  })
}

/**
 * 获取单个案例详情
 * @param data
 * @returns {AxiosPromise}
 */
export function getCaseInfo(data) {
  return request({
    url: 'api/getCaseInfo',
    method: 'post',
    params: data
  })
}

/**
 * 获取装修攻略列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getStrategyPC(data) {
  return request({
    url: 'api/getStrategyPC',
    method: 'post',
    params: data
  })
}

/**
 * 删除装修攻略
 * @param data
 * @returns {AxiosPromise}
 */
export function deleteStrategy(data) {
  return request({
    url: 'api/deleteStrategy',
    method: 'post',
    params: data
  })
}

/**
 * 添加或修改装修攻略
 * @param data
 * @returns {AxiosPromise}
 */
export function addOrEditStrategy(data) {
  return request({
    url: 'api/addOrEditStrategy',
    method: 'post',
    params: data
  })
}

/**
 * 根据id获取单个装修攻略
 * @param data
 * @returns {AxiosPromise}
 */
export function getStrategyInfo(data) {
  return request({
    url: 'api/getStrategyInfo',
    method: 'post',
    params: data
  })
}

/**
 * 获取面积字典
 * @param data
 * @returns {AxiosPromise}
 */
export function getAreaList(data) {
  return request({
    url: 'api/getAreaList',
    method: 'post',
    params: data
  })
}

/**
 * 获取品牌字典
 * @param data
 * @returns {AxiosPromise}
 */
export function getBrand(data) {
  return request({
    url: 'api/getBrand',
    method: 'post',
    params: data
  })
}

/**
 * 获取居室字典
 * @param data
 * @returns {AxiosPromise}
 */
export function getBedRoomList(data) {
  return request({
    url: 'api/getBedRoomList',
    method: 'post',
    params: data
  })
}
